





































































































import {Component, Mixins, Vue, Prop} from 'vue-property-decorator';
import { CampaignCountdownBar } from '@webstacz/vue-components';
import {Mixin} from "@/mixins";
import Voucher from "@/components/Voucher.vue";
import store from "@/store";

@Component({
    components: {
        Voucher,
        CampaignCountdownBar,
    },
})
export default class Sidebar extends Mixins(Mixin) {

    //<editor-fold desc="Private properties">
    store = store();
    showCampaignCountdown: boolean = true;
    //</editor-fold>

    //<editor-fold desc="Props">
    //</editor-fold>

    //<editor-fold desc="Refs">
    //</editor-fold>

    //<editor-fold desc="Watchers">
    //</editor-fold>

    //<editor-fold desc="Getters">
    get campaignCountdownDate() {
        if (this.store.serverData.currentHeaderBar) {
            return new Date(this.store.serverData.currentHeaderBar.date.to);
        }

        return null;
    }

    get campaignCountdownBarTexts() {
        const ranges = this.store.serverData.currentHeaderBar!.voucher.ranges;
        const maxValue = Math.max(...ranges.map(range => range.value));
        const maxFormattedValue = ranges.find(range => range.value === maxValue)!.formattedValue;

        return {
            text: this.T('campaign-countdown-text', { value: maxFormattedValue }),
            date: {
                days: this.T('campaign-countdown-days'),
                hours: this.T('campaign-countdown-hours'),
                minutes: this.T('campaign-countdown-minutes'),
                seconds: this.T('campaign-countdown-seconds')
            },
            activate: this.T(
                'campaign-countdown-activate',
                { code: this.store.serverData.currentHeaderBar!.voucher.code }
            )
        }
    }

    get voucherPrice(): string {
        return this.store.serverData.additionalOptions.voucher.priceNumber! > 0
            ? `-${this.store.serverData.additionalOptions.voucher.price!}`
            : this.store.serverData.additionalOptions.voucher.price!
    }
    //</editor-fold>

    //<editor-fold desc="Hooks">
    mounted() {
        setInterval(() => {
            this.showCampaignCountdown = !!this.campaignCountdownDate && new Date() < this.campaignCountdownDate;
        }, 1000)
    }
    //</editor-fold>

    //<editor-fold desc="Methods">
    openHeaderBarPopup() {
        document.dispatchEvent(new CustomEvent('openHeaderBarVoucherPopup'));
    }
    //</editor-fold>
}
